<template>
  <div>
    <div class="mt-4">
      <v-card-title>
        <v-row class="py-2">
          <v-col lg="6" md="6" sm="12" class="col-12">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-4" v-on="on" fab dark small color="primary" @click="agregar()">
                  <v-icon small dark>fas fa-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-4" v-on="on" fab dark small color="primary" @click="openDialogUpload()">
                  <v-icon small dark>fas fa-cloud-upload-alt</v-icon>
                </v-btn>
              </template>
              <span>Importar</span>
            </v-tooltip>
          </v-col>
          <v-col lg="6" md="6" sm="12" class="col-12">
            <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="dateRangeText"
                  label="Rango Fechas"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker v-model="dates" range no-title scrollable color="primary"> </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-title>
      <v-dialog v-model="dialogUpload" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">Importar</v-card-title>
          <div class="px-5">
            <v-file-input
              show-size
              label="Archivo"
              accept=".xlsx,.xls,.csv"
              truncate-length="50"
              @change="changeFileUpload"
            ></v-file-input>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialogUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="acceptDialogUpload">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        v-model="seleccionado"
        :headers="headers"
        :items="listadoProgramacionComedor"
        class="elevation-0 border"
        :single-select="singleSelect"
        item-key="idprogramacioncomedor"
        show-select
        multi-sort
        :mobile-breakpoint="0"
        no-data-text="No se encontraron datos"
        no-results-text="No se encontraron datos"
        :items-per-page="pagina"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-divider class="mx-4" inset vertical></v-divider>
            <div class="text-center">
              <v-menu bottom offset-y ref="openMenu">
                <template v-slot:activator="{ on: menu }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn class="mx-2" fab small color="primary" v-on="{ ...tooltip, ...menu }">
                        <v-icon small>fas fa-ellipsis-v</v-icon>
                      </v-btn>
                    </template>
                    <span>Acciones</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-item @click.stop="asignarStock('H')">
                    <v-list-item-title> Asignar Stock </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-toolbar>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.programareleccion="{ item }">
          <v-icon color="red" small v-if="item.programareleccion == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.programareleccion == 1">fas fa-check</v-icon>
        </template>
        <template v-slot:item.tipoplato="{ item }">
          <span v-if="item.tipoplato == 'A'">ALMUERZO</span>
          <span v-if="item.tipoplato == 'D'">DESAYUNO</span>
          <span v-if="item.tipoplato == 'C'">CENA</span>
        </template>
        <!-- <template v-slot:item.paragerentes="{ item }">
          <v-icon color="red" small v-if="item.paragerentes == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.paragerentes == 1">fas fa-check</v-icon>
        </template>
        <template v-slot:item.parajefes="{ item }">
          <v-icon color="red" small v-if="item.parajefes == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.parajefes == 1">fas fa-check</v-icon>
        </template>
        <template v-slot:item.paraobreros="{ item }">
          <v-icon color="red" small v-if="item.paraobreros == 0">fas fa-times</v-icon>
          <v-icon color="green" small v-else-if="item.paraobreros == 1">fas fa-check</v-icon>
        </template>
        <template v-slot:item.aceptaproveedor="{ item }">
          <v-icon color="green" small v-if="item.aceptaproveedor == 1">fas fa-check</v-icon>
          <v-icon color="red" small v-else-if="item.aceptaproveedor == 0">fas fa-times</v-icon>
        </template> -->
        <template v-slot:item.validacomedor="{ item }">
          <v-icon color="green" small v-if="item.validacomedor == 1">fas fa-check</v-icon>
          <v-icon color="red" small v-else-if="item.validacomedor == 0">fas fa-times</v-icon>
        </template>
        <template v-slot:item.activo="{ item }">
          <v-icon color="red" small v-if="item.activo == 0">fas fa-square-full</v-icon>
          <v-icon color="green" small v-else-if="item.activo == 1">fas fa-square-full</v-icon>
        </template>
      </v-data-table>
      <div v-if="showLoading" class="progress-background">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </div>
      <v-dialog v-model="dialogStock" persistent width="500">
        <v-card>
          <v-card-title class="headline">Asignar Stock</v-card-title>
          <div class="px-5">
            <v-text-field
              label="Cantidad Stock"
              :rules="rules"
              v-model="valueStock"
              @keydown="soloNumeros($event)"
            ></v-text-field>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closedialogo">Cancelar</v-btn>
            <v-btn color="primary" text @click="aceptarDialogo">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" :timeout="2000" :color="color">
        {{ text }}
        <v-btn :color="color == 'red' ? 'white' : 'primary'" text @click="snackbar = false">
          Cerrar
        </v-btn>
      </v-snackbar>
      <!--<v-sheet height="64">
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <v-btn icon class="ma-2" @click="prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-btn icon class="ma-2" @click="next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
      </v-sheet>-->
      <!-- <v-sheet height="600">
        <v-calendar
          ref="calendar"
          color="primary"
          end="2020-11-30"
          v-model="calendar"
          type="month"
          :events="events"
          :event-color="getColor"
          :event-margin-bottom="5"
          @change="updateRange"
        />
      </v-sheet>-->
      <GestionProgramacionMenuPopup
        ref="gestionpopup"
        @guardar="guardar"
        @deleteDuplicados="deleteDuplicados"
        :listadoProgramacion="listadoProgramacionComedorAux"
        :dialog="dialogPopup"
        @open="openPopup()"
        @close="closePopup()"
      ></GestionProgramacionMenuPopup>
    </div>
  </div>
</template>

<script>
import ProgramacionMenuService from '@/CYC/comedor/gestionprogramacionmenu/services/ProgramacionMenuService.js';
import moment from 'moment';
import XLSX from 'xlsx';

export default {
  name: 'GestionProgramacionMenuLista',
  components: {
    GestionProgramacionMenuPopup: () => import('../components/GestionProgramacionMenuPopup')
  },
  data: () => ({
    color: '',
    fileUpload: null,
    dialogUpload: false,
    showLoading: false,
    valueStock: '',
    dialogStock: false,
    snackbar: false,
    text: '',
    rules: [(v) => v.length > 0 || 'El campo es obligatorio.'],
    dates: [],
    programacionMenuService: null,
    calendar: '',
    start: null,
    end: null,
    events: [
      { start: '2020-10-17', end: '2020-10-17', name: 'Arroz con pollo', color: 'blue' },
      { start: '2020-10-15', end: '2020-10-15', name: 'Pesacado Frito', color: 'orange' },
      { start: '2020-10-14', end: '2020-10-14', name: 'Arroz Chaufa', color: 'purple' },
      { start: '2020-10-13', end: '2020-10-13', name: 'Tallarines Rojos', color: 'teal' },
      { start: '2020-10-13', end: '2020-10-13', name: 'Desayuno Express', color: 'green' },
      { start: '2020-11-30', end: '2020-11-30', name: 'Desayuno Americano', color: 'red' }
    ],
    dialogPopup: false,
    seleccionado: [],
    headers: [
      //{ text: 'idempresa', value: 'idempresa', width: '150' },
      { text: 'idcliente', value: 'idcliente', width: '150' },
      { text: 'razonsocial', value: 'razonsocial', width: '200' },
      { text: 'idprogramacioncomedor', value: 'idprogramacioncomedor', width: '250' },
      //{ text: 'idplato', value: 'idplato', width: '150' },
      { text: 'plato', value: 'plato', width: '200' },
      { text: 'fecha', value: 'fecha', width: '150' },
      { text: 'comedor', value: 'comedor', width: '150' },
      // { text: 'idplanilla', value: 'idplanilla', width: '150' },
      { text: 'tipoplato', value: 'tipoplato', width: '150' },
      { text: 'stockbase', value: 'stockbase', width: '150' },
      { text: 'stockadicional', value: 'stockadicional', width: '200' },
      { text: 'idusuario', value: 'idusuario', width: '150' },
      { text: 'semana', value: 'semana', width: '150' },
      { text: 'programareleccion', value: 'programareleccion', width: '150' },
      { text: 'inicioprogramareleccion', value: 'inicioprogramareleccion', width: '150' },
      { text: 'finprogramareleccion', value: 'finprogramareleccion', width: '150' },
      // { text: 'paraempleados', value: 'paraempleados', width: '150' },
      // { text: 'paragerentes', value: 'paragerentes', width: '150' },
      // { text: 'parajefes', value: 'parajefes', width: '150' },
      // { text: 'paraobreros', value: 'paraobreros', width: '150' },
      // { text: 'aceptaproveedor', value: 'aceptaproveedor', width: '200' },
      // { text: 'validacomedor', value: 'validacomedor', width: '150' },
      { text: 'activo', value: 'activo', width: '150', align: 'center' }
    ],
    listadoProgramacionComedor: [],
    listadoProgramacionComedorAux: [],
    singleSelect: false
  }),
  computed: {
    pagina() {
      if (screen.width <= 600) return 5;
      else return 15;
    },
    dateRangeText() {
      return this.dates.join(' ~ ');
    }
  },
  watch: {
    async dates(val) {
      if (val.length <= 1) return;
      await this.iniciaListado();
    }
  },
  methods: {
    openPopup() {
      this.dialogPopup = true;
    },
    closePopup() {
      this.dialogPopup = false;
      this.listadoProgramacionComedorAux = [];
      this.closeDialogUpload();
    },
    open() {
      this.$emit('open');
    },
    close() {
      this.$emit('close');
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    openDialogUpload() {
      this.dialogUpload = true;
    },
    closeDialogUpload() {
      this.fileUpload = null;
      this.dialogUpload = false;
    },
    changeFileUpload($event) {
      this.fileUpload = $event;
    },
    async acceptDialogUpload() {
      if (this.fileUpload === null || this.fileUpload === undefined) return;
      let reader = new FileReader();
      reader.onload = async (e) => {
        let data = e.target.result;
        let fixedData = this.fixdata(data);
        let workbook = XLSX.read(btoa(fixedData), { type: 'base64' });
        let firstSheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[firstSheetName];
        const res = XLSX.utils.sheet_to_json(worksheet);
        this.dialogUpload = false;
        await this.visualizarProgramacion(res);
      };
      reader.readAsArrayBuffer(this.fileUpload);
    },
    fixdata(data) {
      var o = '',
        l = 0,
        w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    visualizarProgramacion(val) {
      console.log('este es el val', val);

      val.forEach((el) => {
        this.listadoProgramacionComedorAux.push({
          idcliente: el.idcliente,
          idprogramacioncomedor: el.idprogramacioncomedor,
          fecha: el.fecha,
          tipoplato: el.tipoplato,
          idplato: el.idplato,
          stockadicional: el.stockadicional,
          comedor: el.comedor,
          programareleccion: el.programareleccion,
          inicioprogramareleccion: Object.prototype.hasOwnProperty.call(el, 'inicioprogramareleccion')
            ? el.inicioprogramareleccion
            : '',
          finprogramareleccion: Object.prototype.hasOwnProperty.call(el, 'finprogramareleccion')
            ? el.finprogramareleccion
            : ''
        });
      });
      this.openPopup();
    },
    deleteDuplicados() {
      this.listadoProgramacionComedorAux = this.listadoProgramacionComedorAux.filter((el) => el.error === false);
      this.$refs.gestionpopup.showEliminar = false;
    },
    async guardar() {
      if (this.listadoProgramacionComedorAux.length <= 0) return;
      const res = await this.programacionMenuService.post().execResource('dumpprogramacioncomedor', {
        exportacion: [...this.listadoProgramacionComedorAux],
        idempresa: localStorage.getItem('emp'),
        usuario: localStorage.getItem('user')
      });
      if (res.status) {
        this.$refs.gestionpopup.showEliminar = false;
        this.$refs.gestionpopup.text = res.message;
        this.$refs.gestionpopup.snackbar = true;
        this.listadoProgramacionComedorAux = [];
        this.closePopup();
        this.iniciaListado();
      } else {
        this.$refs.gestionpopup.showEliminar = true;
        this.listadoProgramacionComedorAux.map((element) => {
          element.error = false;
          return element;
        });
        for (const el of res.message) {
          this.listadoProgramacionComedorAux.map((element) => {
            if (el.idprogramacioncomedor.toString() === element.idprogramacioncomedor) {
              element.error = true;
            }
            return element;
          });
        }
        this.$refs.gestionpopup.text = 'Error en datos duplicados';
        this.$refs.gestionpopup.snackbar = true;
      }
    },
    openDialogo() {
      this.dialogStock = true;
    },
    closedialogo() {
      this.dialogStock = false;
    },
    getColor(event) {
      return event.color;
    },
    asignarStock() {
      if (this.seleccionado.length > 0) {
        this.openDialogo();
      } else {
        this.snackbar = true;
        this.text = 'Seleccione al menos un elemento de la lista.';
        this.color = 'red';
      }
    },
    soloNumeros(event) {
      if (
        (event.keyCode < 48 || event.keyCode > 57) &&
        (event.keyCode < 96 || event.keyCode > 105) &&
        event.keyCode !== 190 &&
        event.keyCode !== 110 &&
        event.keyCode !== 8 &&
        event.keyCode !== 9
      ) {
        event.preventDefault();
      }
    },
    async aceptarDialogo() {
      this.open();
      const data = [];
      this.seleccionado.forEach((element) => {
        if (element.activo == 1) {
          data.push(element.idprogramacioncomedor);
        }
      });
      const res = await this.programacionMenuService.put().execResource('asignarstock', {
        data: data,
        value: this.valueStock
      });
      this.close();
      this.closedialogo();
      this.color = '';
      this.text = res.message;
      this.snackbar = true;
      this.seleccionado = [];
      this.valueStock = '';
      await this.iniciaListado();
    },
    async iniciaListado() {
      this.open();
      this.listadoProgramacionComedor = [];
      const res = await this.programacionMenuService.get().execResource('progcomedor', {
        idempresa: localStorage.getItem('emp'),
        fechainicio: Date.parse(this.dates[0]) < Date.parse(this.dates[1]) ? this.dates[0] : this.dates[1],
        fechafin: Date.parse(this.dates[1]) > Date.parse(this.dates[0]) ? this.dates[1] : this.dates[0],
        activo: 1
      });
      if (res.length > 0) {
        this.listadoProgramacionComedor = res;
      }
      this.close();
    },
    agregar() {
      this.$router.push({ path: '/comedor/gestion_programacion_menu/agregar' });
    },
    async seleccion(env) {
      await this.initialize(env);
    },
    updateRange({ start }) {
      this.calendar = start.date;
    }
  },
  async mounted() {
    this.programacionMenuService = this.$httpService(new ProgramacionMenuService(), this);
    this.dates = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
  }
};
</script>
